// extracted by mini-css-extract-plugin
module.exports = {"btnSubmit":"style_btnSubmit__DsUsx","btnFacebook":"style_btnFacebook__DViN6","btnGoogle":"style_btnGoogle__PGBMN","loginFailure":"style_loginFailure__2eSJK"};